import React, { useMemo } from 'react';
import { JustWinContainer } from 'Components/Modals/Investment/JustWinDialog/JustWinContainer';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import fr from 'facet-rest';
import { FDStack } from '@facet-wealth/design';

const InvestmentsTabJustWin = () => {
  const { householdResource, refreshHouseholdResource } = useSimpleHousehold();

  // JustWinPM1Container is memoized because they are in the render path. I don't want to re-fetch the justWin resources on
  // every single render.
  const JustWinPM1Container = useMemo(() => householdResource.withRelationship(fr.relationships.justWinPM1.name,
    (rel) => () => <JustWinContainer relationship={rel} onSubmit={refreshHouseholdResource} />,
    () => null), [householdResource.instanceId()]);

  // JustWinPM2Container is memoized because they are in the render path. I don't want to re-fetch the justWin resources on
  // every single render.
  const JustWinPM2Container = useMemo(() => householdResource.withRelationship(fr.relationships.justWinPM2.name,
    (rel) => () => <JustWinContainer relationship={rel} onSubmit={refreshHouseholdResource} />,
    () => null), [householdResource.instanceId()]);

  return (
    <FDStack direction={'column'} spacing={2}>
      <JustWinPM1Container />
      <JustWinPM2Container />
    </FDStack>
  );
};

InvestmentsTabJustWin.defaultProps = {};

InvestmentsTabJustWin.propTypes = {};

export { InvestmentsTabJustWin };
